import { getAPI } from "../api/apis";
import mixpanelData from "./mixpanel";

export const workexperience = (value: number, type: number) => {
  let data = value.toString()
  return data.split('.')[type] || 0
}


export const nameConversion = (name: string) => {
  //   let data = name.charAt(0).toUpperCase() + name.slice(1);
  const arr = name.split(" ");
  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  const data = arr.join(" ");
  return data;


}

var a = ['', 'One ', 'Two ', 'Three ', 'Four ', 'Five ', 'Six ', 'Seven ', 'Eight ', 'Nine ', 'Ten ', 'Eleven ', 'Twelve ', 'Thirteen ', 'Fourteen ', 'Fifteen ',
    'Sixteen ', 'Seventeen ', 'Eighteen ', 'Nineteen '];
var b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

export const inWords = (num:any) => {
  if ((num = num.toString()).length > 9) return 'Limit Exceeds';
  let n:any = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) return; var str = '';
  str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
  str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
  str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
  str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
  str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only! ' : '';
  return str;
}



export const getMilliSec = (date: any) => {
  return new Date(date).getTime()
}

export const getMilliSecUTC = (date: any) => {
  let Adate = new Date(date)
  return  Date.UTC(Adate.getFullYear(),Adate.getMonth(),Adate.getDate())
 }

export const convertMilliSecToDateNew = (date: any) => {
  if (date) {
      try 
      { return new Date(date).toDateString() }
      catch {
          return ''
      }
  } else {
      return ''
  }
}

export const submitMixPanel = (response: any) => {
  const data = JSON.parse(localStorage.getItem("profile_metadata") || "") || {}
  const skillsName = data.techStack.map((item: any) => { return (item.skill.skillName) })
  const jobRolesNames: string[] = data.jobRoles.map((item: {id: number, name: string}) => { return(item.name)}) 

  
  mixpanelData('MWP - New Full Profile Submitted', {
    'source': 'Recruiter submits a profile',
    'candidate Name': data && data.firstName,
    'candidate email': data && data.email,
    'distinct_id': localStorage.getItem('Email'),
    'Phone Number': data && data.phoneNumber,
    'skills': skillsName,
    'JobRoles': jobRolesNames,
    'workExperience': data.workExperience,
    'Work Type': response.data[0].profile_metadata.workType && checkWorkType(parseInt(response.data[0].profile_metadata.workType)),
    'Contract Type': response.data[0].profile_metadata.contractType && checkContractType(parseInt(response.data[0].profile_metadata.contractType.contractType)),
    'Availability': response.data[0].profile_metadata.availability && checkAvailabilitymixpanel(response.data[0].profile_metadata.availability.availabilityId, response.data[0].profile_metadata.availability.date),
    'salary': response.data[0].profile_metadata.preference ? response.data[0].profile_metadata.preference.salary && response.data[0].profile_metadata.preference.salary.expectedPay + ' ' + response.data[0].profile_metadata.preference.salary.currencyType + ' ' + response.data[0].profile_metadata.preference.salary.billingType : 'Not Mentioned',
    // 'allocatedTo': response.data[0].allocatedToUserName && response.data[0].allocatedToUserName, 
    // 'sourcedBy': response.data[0].sourced_by && response.data[0].sourced_by,
    // 'ellowStatus': response.data[0].candidate_status && Utils.checkCandidateStatus(response.data[0].candidate_status)

  })
  return
}

export const checkAvailabilitymixpanel = (data: number | undefined, date: number | Date | undefined) => {
  switch (data) {
    case 1: 
     return 'Immediately'
    case 2:
      let newDate: any = new Date(date ? date : '')
      return `I’m getting relieved from my current job by ${newDate} date`
    case 3:
      return `In ${date} weeks after I get the offer`
    case 5:
      return 'Unavailable for jobs'
  }
}

export const detailsAPI = async (data: any) => {

  await getAPI('https://ellow-dev-static-content.s3.ap-south-1.amazonaws.com/details.json')
    .then((data: any) => {
      return data.image;
    })

}

export const makeSideBarActive = (menu: { icon: string, title: string, url: string, active: boolean }[], index: number) => {
  menu.map((item) => item.active = false);
  menu[index].active = true;
  return menu
}

export const checkExpertise = (data: number) => {
  switch (data) {
    case 1: 
     return 'Expert'
    case 2:
      return 'Intermediate'
    case 3:
      return 'Beginner'
  }
}

export const checkCompletion = (data: any) => {
  if (data)
  {
    if (data && data[0] && data[1] && data[2] && data[3] && data[4] && data[5] && data[6] && data[7] && data[8] && data[9] && data[10] && data[11]) {
      return true
    }
    else {
      return false
    }
    }
}

export const checkWorkType = (data: number | undefined) => {
  switch (data) {
    case 1: 
     return 'Contract'
    case 2:
      return 'Permanent full time employee'
    case 3:
      return 'Open for both'
  }
}

export const checkContractType = (data: number | undefined) => {
  
  switch (data) {
    case 1: 
     return 'I’m available for 8hrs/day,40hrs/week'
    case 2:
      return 'I can start part-time immediately and then switch to full-time later on'
    case 3:
      return 'No, I’m not interested in remote work'
  }
}

export const checkTypeofCompany = (id: number) => {
  
  switch (id) {
    case 0:
      return 'A start-up'
    case 1:
      return 'A large company'
    case 2:
      return 'Both'
  }
}

export const checkCareerType = (data: number | undefined) => {
  switch (data) {
    case 1: 
     return 'Career Freelancers'
    case 2:
      return 'Full time employee'
    case 3:
      return 'Open for both'
  }
}

export const checkWorkLocation = (remoteType: number, location?: any) => {
  switch (remoteType) {
    case 0:
      return 'Remote Only'
    case 1:
      return 'Onsite at ' + (location && location.map((item: any) => item.name))
    case 2:
      return 'Hybrid at ' + (location && location.map((item: any) => item.name))
    case 3:
      return 'NA'
  }
}

export const checkJobCriteria = (type: number) => {
  switch (type) {
    case 1:
      return 'Ready to work'
    case 2:
      return 'Ready to hear'
    case 3:
      return 'Not ready yet'
}
}

export const checkAvailability = (data: any, date?: number | Date | undefined) => {
  switch (data.availabilityId) {
    case 1: 
     return 'Immediately'
    case 2:
      let newDate: any = new Date(data.date ? data.date : '').toDateString()
      return `I’m getting relieved from my current job by ${newDate} date`
    case 3:
      return `In ${data.weeks} weeks after I get the offer`
    case 5:
      return 'Unavailable for jobs'
  }
}

// export const newCheckAvailability = (data: any) => {
//   switch (data.availabilityId) {
//     case 1: 
//      return 'Immediately'
//     case 2:
//       let newDate: any = new Date(data.date ? data.date : '')
//       return `I’m getting relieved from my current job by ${newDate} date`
//     case 3:
//       return `In ${data.weeks} weeks after I get the offer`
//     case 5:
//       return 'Unavailable for jobs'
//   }
// }

export const checkJobSearch = (data: number | undefined) => {
  switch (data) {
    case 1: 
     return 'Ready to Work'
    case 2:
      return 'Ready to Hear'
    case 3:
      return 'Not Ready yet'
   }
}

export const checkCompanyType = (data: number | undefined) => {
  switch (data) {
    case 1: 
     return 'A start-up'
    case 2:
      return 'A large company'
    case 3:
      return 'Both'
   }
}

export const checkLocationPreference = (data: number | undefined) => {
  switch (data) {
    case 0: 
     return 'Remote Only'
    case 1:
      return 'Onsite Only'
    case 2:
      return 'Remote and Onsite'
   }
}

export const validation = (val:any) => {
  return val = val.replace(/([A-Z])/g, ' $1')
  // uppercase the first character
  .replace(/^./, (str:any) => str.toUpperCase())
}

export const checkStatus = (data: string) => {
  switch (data) {
    case 'Pending':
      return 'ratingStatus pending'
    case 'Received':
      return 'ratingStatus received'    
  }
}

export const checkTimesheetStatus = (status: string) => {
  switch (status) {
    case '1':
      return {
        value: 'Draft',
        class: 'statusMessage Yellow'
      }
    case '2':
      return {
        value: 'Submitted',
        class: 'statusMessage Yellow'
      }
    case '3':
      return {
        value: 'Approved',
        class: 'statusMessage Green'
      }
    case '4':
      return {
        value: 'Rejected',
        class: 'statusMessage Red'
    }
    default:
      return {
        value: '',
        class: ''
    }
  }
}